import { useLayoutEffect, useState } from 'react';

import { matchRoutes, useLocation } from 'react-router-dom';

import { APP_ROUTES } from '../../../assets/MenuItems';

const routesFilter = ({ route }) => {
  const hasLabel = Boolean(route.breadcrumbs?.label || route.label);
  const isBreadcrumbsEnabled = route.breadcrumbs?.show ?? true;

  return hasLabel && isBreadcrumbsEnabled;
};

const routesMap = (match) => ({
  url: `/#${match.pathname}`,
  urlParams: match.params,
  icon: match.route.icon,
  title: match.route.breadcrumbs?.label || match.route.label,
  enabled: match.route.breadcrumbs?.enabled ?? true,
  menuItem: match.route || {},
});

const useBreadcrumbs = () => {
  const location = useLocation();
  const routes = matchRoutes(APP_ROUTES, location) ?? [];

  const defaultItems = routes.filter(routesFilter).map(routesMap);

  const [breadcrumbsItems, setBreadcrumbsItems] = useState(defaultItems);

  useLayoutEffect(() => {
    setBreadcrumbsItems(defaultItems);
  }, [location.pathname]);

  return {
    defaultItems,
    breadcrumbsItems,
    setBreadcrumbsItems,
  };
};

export default useBreadcrumbs;
